// extracted by mini-css-extract-plugin
export default {"card":"QbLwYjI540DBmgBCMJDo","arrow":"C1lfQUMq6uJ1adVSzVxQ","title":"uVI2GCXbA9Exqc_z8pBH"};